import { createApi } from '@reduxjs/toolkit/query/react';

import { UserOAuthAccount } from '@/slices/auth/auth.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

export type UserOAuthAccountResponse = {
  status: UserOAuthAccount;
};

export const authApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/auth',
  }),
  reducerPath: 'auth',
  tagTypes: ['Auth'],
  endpoints: (build) => ({
    getOAuthStatus: build.query<
      UserOAuthAccount,
      {
        clientKey: string;
      }
    >({
      query: ({ clientKey }) => ({
        url: `/${clientKey}/status`,
        method: 'GET',
      }),
      transformResponse: (response: UserOAuthAccountResponse) =>
        response.status,
      providesTags: (_result, _error, { clientKey }) => [
        { type: 'Auth', id: clientKey },
      ],
    }),
    unlinkOAuthAccount: build.mutation<
      void,
      {
        clientKey: string;
      }
    >({
      query: ({ clientKey }) => ({
        url: `/${clientKey}/unlink`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, { clientKey }) => [
        { type: 'Auth', id: clientKey },
      ],
    }),
  }),
});

export default authApi;
